import React from 'react';
import classnames from 'classnames';
import Timestamp from '../../../../Timestamp';
import { getThumbGlobalClassNames } from '../../helpers';
const StatusThumbHtmlView = ({ deviation , width , height  })=>/*#__PURE__*/ React.createElement("div", {
        style: {
            width,
            height
        },
        className: classnames('daeditor-freeform-root', getThumbGlobalClassNames(deviation))
    }, /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-freeform-body"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-freeform-date"
    }, /*#__PURE__*/ React.createElement(Timestamp, {
        timestamp: deviation.publishedTime
    })), /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-freeform-text"
    }, deviation.textContent && deviation.textContent.excerpt)));
StatusThumbHtmlView.displayName = 'StatusThumbHtmlView';
export default StatusThumbHtmlView;
